import {
  createValidator,
  Rules,
  required,
  pattern,
} from 'src/helpers/validation';
import {
  SSNLastFourFormData,
  PersonalIdNumberData,
} from 'src/components/AdditionalDetails/';

const ssnLastFourRule: Rules<SSNLastFourFormData> = {
  ssnLast4: [
    required({
      message: 'Please enter the last 4 digits of your SSN',
      emptyValues: ['xxxx'],
    }),
    pattern(/^\d{4}?$/, {
      message:
        'Your SSN should only contain numbers. Please enter the last 4 digits of your SSN.',
    }),
  ],
};

const personalIdNumberRule: Rules<PersonalIdNumberData> = {
  personalIdNumber: [
    required({
      message: 'Please enter your Social Security Number',
      emptyValues: ['xxx-xx-xxxx'],
    }),
    pattern(/^[\d\- ]+$/, {
      message: 'Your SSN should only include numbers. Please enter your SSN.',
    }),
  ],
};

export const ssnLastFourValidation = createValidator(ssnLastFourRule);
export const personalIdNumberValidation = createValidator(personalIdNumberRule);



// WEBPACK FOOTER //
// ./src/components/AdditionalDetails/additionalStripeDetailsValidator.tsx